export default __webpack_public_path__ + "static/media/icon-check-circle.3fd09acd.svg";